<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column
            label="序号"
            align="center"
            width="80"
            prop="seq"
          ></el-table-column>
          <el-table-column label="开庭时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.hearing_date || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="案由">
            <template slot-scope="scope">
              {{ scope.row.cause_action || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="案号">
            <template slot-scope="scope">
              {{ scope.row.case_no || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="原告/上诉人/申请人">
            <template slot-scope="scope">
              {{ scope.row.plainTiffFieldName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="被告/被上诉人/被申请人">
            <template slot-scope="scope">
              {{ scope.row.defendantFieldName || "-" }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100px"
            fixed="right"
            align="center"
            fit="true"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看详情"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-document"
                  circle
                  @click="showDetail(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :background="background"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog
      title="开庭公告详情"
      :visible.sync="flag"
      :close-on-click-modal="false"
      width="55%"
      append-to-body
      @close="close"
    >
      <table
        class="info-table"
        cellspacing="0"
        style="width: 100%; height: 100%"
      >
        <tbody>
          <tr>
            <td>开庭日期</td>
            <td>{{ report.hearing_date || "-" }}</td>
            <td>案号</td>
            <td>{{ report.case_no || "-" }}</td>
          </tr>
          <tr>
            <td>案由</td>
            <td>{{ report.cause_action || "-" }}</td>
            <td>承办部门</td>
            <td>{{ report.court || "-" }}</td>
          </tr>
          <tr>
            <td>审判长或主审人</td>
            <td>{{ report.judge || "-" }}</td>
            <td>原告/上诉人/申请人</td>
            <td>{{ report.plainTiffFieldName || "-" }}</td>
          </tr>
          <tr>
            <td>被告/被上诉人/被申请人</td>
            <td colspan="3">{{ report.defendantFieldName || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
  import { getNoticeDetail } from "@/api/workplace/companyInfo";

  export default {
    name: "KaiTingGongGao",

    data() {
      return {
        flag: false,
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",

            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        report: {},
        obj: null,
      };
    },

    methods: {
      getNoticeDetail(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.skip = (this.queryForm.pageNum - 1) * 20;

        getNoticeDetail(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getNoticeDetail(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getNoticeDetail(this.obj);
      },
      showDetail(row) {
        this.flag = true;
        this.report = row;
      },
      close() {
        this.flag = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .info-table {
    border-collapse: collapse;
    font-size: 14px;
    color: #333;

    tr td {
      border: 1px solid #ccc;
      padding: 10px;

      &:nth-of-type(even) {
        width: 35%;
        font-weight: normal;
      }

      &:nth-of-type(odd) {
        width: 15%;
        background: #f5f7fa;
      }
    }
  }
</style>
